export interface DateValidationValue {
  property: string;
  min: Date | undefined;
  max: Date | undefined;
}
